import PartnersPage from "../containers/partners/PartnersPage";
import SEO from "../components/seo";
import { STATIC_PAGES_META } from "../lib/metaDataHelpers";
import { InitialResolver } from "@/lib/use.middlewares";

function Partners() {
  return (
    <>
      <SEO {...STATIC_PAGES_META.partnersPage} />
      <PartnersPage />
    </>
  );
}
Partners.getInitialProps = InitialResolver();

export default Partners;
